import { render, staticRenderFns } from "./ed-viewer-audio-object.component.vue?vue&type=template&id=9dd74b36&scoped=true&"
import script from "./ed-viewer-audio-object.component.ts?vue&type=script&lang=ts&"
export * from "./ed-viewer-audio-object.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-viewer-audio-object.component.scss?vue&type=style&index=0&id=9dd74b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd74b36",
  null
  
)

export default component.exports